import { useEffect } from 'react';
import { generateLocalBusinessSchema } from '../../utils/seo';

const SEOHead = ({ 
  title, 
  description, 
  keywords,
  canonicalUrl,
  ogImage,
  schema 
}) => {
  useEffect(() => {
    // Set title
    if (title) {
      document.title = title;
    }

    // Set meta description
    updateMetaTag('description', description);
    
    // Set meta keywords
    updateMetaTag('keywords', keywords);

    // Set canonical URL
    if (canonicalUrl) {
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = canonicalUrl;
    }

    // Set Open Graph tags
    updateMetaTag('og:title', title, 'property');
    updateMetaTag('og:description', description, 'property');
    updateMetaTag('og:type', 'website', 'property');
    if (ogImage) {
      updateMetaTag('og:image', ogImage, 'property');
    }

    // Set Twitter Card
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);

    // Add schema.org structured data
    const schemas = schema ? [generateLocalBusinessSchema(), schema] : [generateLocalBusinessSchema()];
    
    // Remove existing schema scripts
    document.querySelectorAll('script[type="application/ld+json"]').forEach(el => el.remove());
    
    // Add new schema scripts
    schemas.forEach(schemaData => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schemaData);
      document.head.appendChild(script);
    });

    // Cleanup function
    return () => {
      document.querySelectorAll('script[type="application/ld+json"]').forEach(el => el.remove());
    };
  }, [title, description, keywords, canonicalUrl, ogImage, schema]);

  return null;
};

const updateMetaTag = (name, content, attribute = 'name') => {
  if (!content) return;
  
  let meta = document.querySelector(`meta[${attribute}="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, name);
    document.head.appendChild(meta);
  }
  meta.content = content;
};

export default SEOHead;
